export function uploadDocs(data) {
  return (dispatch, getState) => {
    const { auth } = getState();

    dispatch({ type: UPLOAD_REQUEST });
    return fetch(`/api/documents/`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: UPLOAD_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: UPLOAD_FAILURE, payload: data });
      }
    });
  };
}

export const UPLOAD_REQUEST = "Upload.Request";
export const UPLOAD_SUCCESS = "Upload.Success";
export const UPLOAD_FAILURE = "Upload.Failure";
export const UPLOAD_RESET = "Upload.Reset";
export const UPLOAD_START_BATCH = "UPLOAD_START_BATCH";
